import { render } from "./EmployerView.vue?vue&type=template&id=2d330473&scoped=true"
import script from "./EmployerView.vue?vue&type=script&lang=js"
export * from "./EmployerView.vue?vue&type=script&lang=js"

import "./EmployerView.vue?vue&type=style&index=0&id=2d330473&lang=css"
import "./EmployerView.vue?vue&type=style&index=1&id=2d330473&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d330473"]])

export default __exports__